import { Component, HostBinding, Inject, Input, OnDestroy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { IModalsService, IMODALS_SERVICE, P500UIBaseModal } from '@platform500services/p500-ui-kit';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { QuickModeSettings } from './quick-mode.interfaces';

@Component({
  selector: 'gtd-quick-mode',
  templateUrl: './quick-mode-modal.component.html',
})
export class QuickModeModal extends P500UIBaseModal implements OnDestroy {
  @HostBinding('class') className = 'c-modal c-modal--d -primary';
  @Input() id!: number;
  @Input() settings!: QuickModeSettings;
  @Input() link!: string[] | string;
  @Input() rbacProperty: string;
  private routerSub: Subscription;

  constructor(@Inject(IMODALS_SERVICE) public modalsService: IModalsService, public router: Router) {
    super(modalsService, router);
    this.routerSub = router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        take(1)
      )
      .subscribe(() => {
        this.close();
      });
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }
}
